var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 95.948,
    height: 106.092,
    viewBox: "0 0 95.948 106.092",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #386e3e;\n      }\n\n      .cls-2 {\n        fill: #3f7d46;\n      }\n\n      .cls-3 {\n        fill: #79b543;\n      }\n\n      .cls-4 {\n        fill: #79aed4;\n      }\n\n      .cls-5 {\n        fill: #fffce3;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1877",
    "data-name": "Group 1877",
    transform: "translate(-834.009 -290.403)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    className: "cls-1",
    d: "M881.409,367.225c-24.912-12.709-16.034-55.86-17.827-63.287,23.048,30.731,26.633,54.944,26.633,54.944.256-42.139,1.28-50.078,8.451-61.858,5.122,27.4,5.89,60.561,5.89,60.561,22.023-52.111,32.267-60.561,32.267-60.561-3.073,30.474-20.231,66-20.231,66,17.158-16.32,34.828-15.807,34.828-15.807a119.3,119.3,0,0,1-28.383,19.142C895.593,368.217,881.409,367.225,881.409,367.225Z",
    transform: "translate(-21.464 -4.828)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    className: "cls-2",
    d: "M940.451,364.863c-4.88-33.8-2.561-48.529,0-53.651,2.561,17.414,14.067,48.867,9.714,66.14C942.756,374.21,942.6,379.757,940.451,364.863Z",
    transform: "translate(-75.541 -15.175)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    className: "cls-2",
    d: "M970.822,356.474c1.847-28.257,15.194-55.571,14.255-66.071,7.428,23.867,1.217,53.716-1.11,62.354C981.583,362.086,970.488,361.589,970.822,356.474Z",
    transform: "translate(-99.766 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    className: "cls-3",
    d: "M923.442,445.931c-8.734-15.082-4.636-23.239-10.611-36.872,11.752,7.739,23.174,29.434,21.328,37.492C927.4,447.542,923.442,445.931,923.442,445.931Z",
    transform: "translate(-57.48 -86.53)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    className: "cls-2",
    d: "M1078.377,384.636c5.157-37.25,29.493-48.517,29.493-48.517-3.415,19.633-9.39,52.849-19.292,57.24C1077.31,390.922,1077.413,391.6,1078.377,384.636Z",
    transform: "translate(-177.914 -33.338)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    className: "cls-3",
    d: "M867.022,461.7c-24.306-2.961-28.062-28.836-33.013-32.885,11.78.683,22.023,18.719,30.389,23.421C867.813,457.324,867.022,461.7,867.022,461.7Z",
    transform: "translate(0 -100.936)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    className: "cls-3",
    d: "M1003,405.759c.04-20.393,9.1-43.232,18.951-50.092-2.561,22.024-4.98,50.961-8.124,53.779C1007.411,411.025,1002.995,408.981,1003,405.759Z",
    transform: "translate(-123.237 -47.594)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    className: "cls-3",
    d: "M1051.187,446.63c5.136-20.784,16.916-36.176,25.623-37.571-7.938,6.287-8.707,31.64-15.237,36.89C1054.419,448.382,1051.187,446.63,1051.187,446.63Z",
    transform: "translate(-158.377 -86.53)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    className: "cls-4",
    d: "M940.806,578.029H891.135a3.748,3.748,0,0,1-3.347-2.063h0a81.518,81.518,0,0,1-8.694-36.63h73.753a81.519,81.519,0,0,1-8.693,36.63h0A3.747,3.747,0,0,1,940.806,578.029Z",
    transform: "translate(-32.878 -181.534)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    className: "cls-5",
    d: "M897.779,560.4s-2.432-5.069,0-9.175A9.63,9.63,0,0,1,897.779,560.4Z",
    transform: "translate(-45.716 -190.204)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    className: "cls-5",
    d: "M923,640.842s-2.433-5.069,0-9.175A9.629,9.629,0,0,1,923,640.842Z",
    transform: "translate(-64.109 -248.867)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    className: "cls-5",
    d: "M1018.8,645.251s-2.433-5.069,0-9.175A9.629,9.629,0,0,1,1018.8,645.251Z",
    transform: "translate(-133.969 -252.082)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    className: "cls-5",
    d: "M1008.181,562.291s-2.433-5.069,0-9.175A9.63,9.63,0,0,1,1008.181,562.291Z",
    transform: "translate(-126.226 -191.584)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    className: "cls-5",
    d: "M961.2,599.494s-2.433-5.069,0-9.175A9.63,9.63,0,0,1,961.2,599.494Z",
    transform: "translate(-91.968 -218.714)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    className: "cls-5",
    d: "M1069.977,599.78s-2.433-5.069,0-9.175A9.631,9.631,0,0,1,1069.977,599.78Z",
    transform: "translate(-171.291 -218.923)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    className: "cls-5",
    d: "M1105.919,643.99s-2.433-5.069,0-9.175A9.63,9.63,0,0,1,1105.919,643.99Z",
    transform: "translate(-197.502 -251.163)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    className: "cls-5",
    d: "M1122.944,562.291s-2.433-5.069,0-9.175A9.63,9.63,0,0,1,1122.944,562.291Z",
    transform: "translate(-209.917 -191.584)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlant);
export default __webpack_public_path__ + "static/media/plant.f81208d58fe072355003685e6b030095.svg";
export { ForwardRef as ReactComponent };